export default {
  baseUrl: '/power-cable-portal',
  baseUrl2: '/power-cable/',
  POWER_CABLE_PAY: '/power-cable-pay',
  POWER_CABLE_BASE: '/power-cable-base',
  POWER_CABLE_LOGISTICS: '/power-cable-logistics',
  POWER_CABLE_REPORT: '/power-cable-report',
  POWER_CABLE_FINANCIAL: '/power-cable-financial',
  POWER_CABLE_TICKET: '/power-cable-ticket',
  POWER_CABLE_AUTH: '/power-cable-auth',
  POWER_CABLE_INVOICE: '/power-cable-invoice',
}
